import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Table, Button, Form, Input, Select, Popover, Spin, InputNumber, DatePicker } from 'antd';
import { CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, EyeOutlined, EditOutlined, CheckCircleOutlined } from '@ant-design/icons';
import Message from '../../component/message/message';
import moment from 'moment';//日期格式化导包
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import $ from 'jquery';

import trans from './translation';
import './jobApplicationRecord.css';
import tag1 from '../../public/img/tag/tag1.png';
import tag2 from '../../public/img/tag/tag2.png';
import { useLocation } from 'react-router-dom';
const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;

const JobApplicationRecord = (props) => {

    const messageRef = useRef();
    const [tabIndex, setTabIndex] = useState("1");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("");
    const [isAudit, setIsAudit] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState(useLocation().model ?? {});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isDisabled, setIsDisabled] = useState(false);
    const [form] = Form.useForm();
    const [jobApplModel, setJobApplModel] = useState({});

    const tableColumns = {
        companyName: "company_name",
        jobId: "job_id",
        jobTitle: "job_title",
    }

    useEffect(() => {
        search(pageSize, 1, "N");
    }, []);

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.progCodeList = Config.userInfo?.progCodeList
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("jobApplication/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (tabIndex !== "1") {
                setIsDisabled(false);
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const view = (model, e) => {
        messageShowHandler();
        e.stopPropagation();
        searchById(model.jobApplId);
        setFlag("view");
        setTabIndex("2");
        setIsDisabled(true);
    }

    const update = (model, e) => {
        messageShowHandler();
        e.stopPropagation();
        searchById(model.jobApplId);
        setFlag("edit");
        setTabIndex("2");
        setIsDisabled(true);
    }

    const searchById = (jobId) => {
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("jobApplication/searchById", jobId).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                initForm(model)
                setJobApplModel(model);
                let jobDesc = model?.jobDesc?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
                $("#jobDesc").empty().append(jobDesc);
                let jobRequirement = model?.jobRequirement?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
                $("#jobRequirement").empty().append(jobRequirement);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            jobApplStatus: model.jobApplStatus ?? "",
            firstName: model.firstName ?? "",
            lastName: model.lastName ?? "",
            email: model.email ?? '',
            contactPhone: model.contactPhone ?? '',
            whatsApp: model.whatsApp ?? '',
            weChat: model.weChat ?? '',
            linkedIn: model.linkedIn ?? '',
            personalWeb: model.personalWeb ?? '',
        });
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const cancel = () => {
        messageShowHandler();
        clearSelect();
        setTabIndex("1");
        setIsDisabled(false);
        search(pageSize, current, "Y");
    }

    const downloadFile = (item, flag) => {
        if (!Base.stopClick()) {
            return;
        }
        if (flag) {
            item.url = Config.studentFiles + item.path;
        } else {
            item.url = Config.jobApplFiles + item.path;
        }
        Base.downloadFile(item.url + '?' + Config.sasToken, item.name)
        // if (item.lastModified) {
        //     return;
        // }
        // if (flag) {
        //     item.code = "STUDENT_PATH";
        // } else {
        //     item.code = "JOB_APPL_PATH";
        // }
        // setIsLoad(true);
        // setSpinInfo(trans.download[Config.backLang]);
        // fetch(Config.apiDownloadServer + "downloadFile/downloadFile", {
        //     method: 'POST',
        //     body: JSON.stringify(item),
        //     headers: Config.header,
        //     mode: 'cors',
        //     cache: 'default'
        // }).then(res => res.blob()).then(blob => {
        //     if (blob.type == "application/json") {
        //         var reader = new FileReader();
        //         reader.onload = e => {
        //             var data = JSON.parse(e.target.result);
        //             errFrameShow("error", data.msg);
        //         }
        //         reader.readAsText(blob);
        //     } else {
        //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
        //             window.navigator.msSaveOrOpenBlob(blob, item.name);
        //         } else {// for Non-IE (chrome, firefox etc.)
        //             var a = document.createElement('a');
        //             document.body.appendChild(a);
        //             a.style = 'display: none';
        //             var url = window.URL.createObjectURL(blob);
        //             a.href = url;
        //             a.download = item.name;
        //             a.click();
        //             a.remove();
        //             window.URL.revokeObjectURL(url);
        //         }
        //     }
        // }).catch(err => { }).finally(() => setIsLoad(false));
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const onFinish = (values) => {
        messageShowHandler();
        let model = {
            ...values,
            studentUserCode: jobApplModel.studentUserCode,
            studentModuleId: jobApplModel.studentModuleId,
            jobApplId: jobApplModel.jobApplId,
            lastUpdatedDate: jobApplModel.lastUpdatedDate
        }
        setIsLoad(true)
        Base.callBackApi("jobApplication/update", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                searchById(data.object)
                setFlag("edit");
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    /*eslint-disable*/
    const columns = [
        {
            title: trans.industrialPartner[Config.backLang],
            dataIndex: 'companyName',
            className: 'tableWidth18',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'companyName') },
        },
        {
            title: trans.jobId[Config.backLang],
            dataIndex: 'jobId',
            className: 'tableWidth8',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobId') },
        },
        {
            title: trans.jobTitle[Config.backLang],
            dataIndex: 'jobTitle',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobTitle') },
            ellipsis: true,
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className="jobPostContent">{text}</div>
            </Popover>
        },
        {
            title: trans.programme[Config.backLang],
            dataIndex: 'progCode',
            className: 'tableWidth12',
        },
        {
            title: trans.programmeTitle[Config.backLang],
            dataIndex: 'progTitle',
            className: 'tableWidth15',
            ellipsis: true,
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className="jobPostContent">{text}</div>
            </Popover>
        },
        {
            title: trans.studentName[Config.backLang],
            className: 'tableWidth10',
            render: (text, record) => <div>{record.firstName + " " + record.lastName}</div>
        },
        {
            title: trans.applyDate[Config.backLang],
            dataIndex: 'applyDate',
            className: 'tableWidth10',
            render: (text) => text ? moment(text).format(Config.dateFormat5) : ""
        },
        {
            title: trans.jobApplStatus[Config.backLang],
            dataIndex: 'jobApplStatus',
            className: 'tableWidth12',
            render: (text) => ContextHandler.getMapValue('jobApplStatusMap', text)
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: 'sysControls ',
            fixed: 'right',
            width: 200,
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysUpdate' onClick={(e) => view(record, e)} hidden={Config.funcInfo.canView === "N"}><EyeOutlined /> {trans.view[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];
    /*eslint-enable*/

    return (
        <div id="container" className="template jobApplicationRecord">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysSearchRow sysSearchBox'>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.studentName[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.studentName || ''}
                                                placeholder={trans.studentName[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('studentName', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.jobTitle[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.jobTitle || ''}
                                                placeholder={trans.jobTitle[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('jobTitle', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.industrialPartner[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.companyName || ''}
                                                placeholder={trans.industrialPartner[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('companyName', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.jobApplStatus[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Select className='sysSelect'
                                                value={searchModel.jobApplStatus || ''}
                                                onChange={(value) => searchChange('jobApplStatus', value)}>
                                                <Option value=''></Option>
                                                {context.jobApplStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 1900 }}
                                    rowKey="jobApplId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                        onChange: onChange,                  //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                        total: tablesCount,        //总共多少条数据
                                        current: current,       //当前页
                                        pageSize: pageSize,  //每页显示多少条数据
                                        defaultCurrent: 1,          //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.jobApplicationRecord[Config.backLang]} forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className="sysBodyRow">
                                    <div className="userRoleTitleRow" style={{ marginTop: "0px" }}>{trans.jobPosting[Config.backLang]}</div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.jobId[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Input type="text" placeholder={trans.jobId[Config.backLang]} value={jobApplModel?.jobId} disabled />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.jobTitle[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Input type="text" placeholder={trans.jobTitle[Config.backLang]} value={jobApplModel?.jobTitle} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.programme[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Input type="text" placeholder={trans.programme[Config.backLang]} value={jobApplModel?.progCode} disabled />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.programmeTitle[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Input type="text" placeholder={trans.programmeTitle[Config.backLang]} value={jobApplModel?.progTitle} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className="sysCol">
                                        <div className="sysParam">{trans.expectDate[Config.backLang]}</div>
                                        <div className="sysInput salaryInput">
                                            <DatePicker placeholder={trans.startDate[Config.backLang]}
                                                value={jobApplModel.expCommenceDate ? moment(new Date(jobApplModel.expCommenceDate), Config.dateFormat5) : null}
                                                className="parts-numberInput datePickerAllWidth"
                                                disabled
                                                format={Config.dateFormat5} />
                                            -
                                            <DatePicker placeholder={trans.endDate[Config.backLang]}
                                                value={jobApplModel.expEndDate ? moment(new Date(jobApplModel.expEndDate), Config.dateFormat5) : null}
                                                className="parts-numberInput datePickerAllWidth"
                                                disabled
                                                format={Config.dateFormat5} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.industrialPartner[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Input type="text" placeholder={trans.industrialPartner[Config.backLang]} value={jobApplModel?.companyName} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.positionType[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Input type="text" placeholder={trans.positionType[Config.backLang]} value={jobApplModel?.positionTypeVal} disabled />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.jobType[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Input type="text" placeholder={trans.jobType[Config.backLang]} value={jobApplModel?.jobTypeVal} disabled />
                                        </div>
                                    </div>
                                </div>
                                {Base.isNotEmpty(jobApplModel.otherDesc) ?
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam">{trans.otherDesc[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <TextArea rows={3} placeholder={trans.otherDesc[Config.backLang]} value={jobApplModel?.otherDesc} disabled />
                                            </div>
                                        </div>
                                    </div>
                                    : ""}
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.salary[Config.backLang]}</div>
                                        <div className="sysInput salaryInput">
                                            <InputNumber className="sysInputNumber" placeholder="Range From"
                                                precision={0} maxLength={14} disabled value={jobApplModel?.salaryRangeFrom} />
                                            ~
                                            <InputNumber className="sysInputNumber" placeholder="Range To"
                                                precision={0} maxLength={14} disabled value={jobApplModel?.salaryRangeTo} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.unit[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Input type="text" placeholder={trans.unit[Config.backLang]} value={jobApplModel?.unitVal} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="sysRow">
                                    <div className="sysCol">
                                        <div className="sysParam">{trans.estimatedNoOfDaysAWeek[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <InputNumber className="sysInputNumber" placeholder={trans.estimatedNoOfDaysAWeek[Config.backLang]}
                                                precision={0} maxLength={1} disabled value={jobApplModel?.estimatedNoOfDaysAWeek} />
                                        </div>
                                    </div>
                                    <div className="sysCol">
                                        <div className="sysParam">{trans.estimatedNoOfHoursAWeek[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <InputNumber className="sysInputNumber" placeholder={trans.estimatedNoOfHoursAWeek[Config.backLang]}
                                                precision={0} maxLength={3} disabled value={jobApplModel?.estimatedNoOfHoursAWeek} />
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.workLocation[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Input type="text" placeholder={trans.workLocation[Config.backLang]} value={jobApplModel?.cityName ? jobApplModel?.cityName + ", " + jobApplModel?.workLocName : jobApplModel?.workLocName} disabled />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.jobPostApprovedDate[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <DatePicker placeholder={trans.jobPostApprovedDate[Config.backLang]}
                                                className="parts-numberInput datePickerAllWidth"
                                                value={jobApplModel.eventDate ? moment(new Date(jobApplModel.eventDate), Config.dateFormat5) : null}
                                                disabled
                                                format={Config.dateFormat5} />
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.jobDesc[Config.backLang]}</div>
                                        <div className="sysInputs editor">
                                            <div id="jobDesc" className='jobPostDesc'></div>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.jobRequirement[Config.backLang]}</div>
                                        <div className="sysInputs editor">
                                            <div id="jobRequirement" className='jobPostDesc'></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysBodyRow">
                                    <div className="userRoleTitleRow">{trans.studentInfo[Config.backLang]}</div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.jobApplId[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Input type="text" placeholder={trans.jobApplId[Config.backLang]} value={jobApplModel?.jobApplId} disabled />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.studentUserCode[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Input type="text" placeholder={trans.studentUserCode[Config.backLang]} value={jobApplModel?.studentUserCode} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.applyDate[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <DatePicker placeholder={trans.applyDate[Config.backLang]}
                                                className="parts-numberInput datePickerAllWidth"
                                                value={jobApplModel.applyDate ? moment(new Date(jobApplModel.applyDate), Config.dateFormat5) : null}
                                                disabled
                                                format={Config.dateFormat5} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.jobApplStatus[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="jobApplStatus"
                                            >
                                                <Select placeholder={trans.jobApplStatus[Config.backLang]} className='sysSelect' disabled={flag !== 'edit'}>
                                                    {context.jobApplStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.studentEmail[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="email"
                                                rules={[
                                                    { required: true },
                                                    { pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: 'Incorrect Email format.' },
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.studentEmail[Config.backLang]} maxLength={50} disabled={flag !== 'edit'} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">Contact Phone</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="contactPhone"
                                                rules={[
                                                    { required: false, },
                                                ]}
                                                getValueFromEvent={(e) => e.target.value.replace(/\D/g, '')}
                                            >
                                                <Input type="text" placeholder="Contact Phone" maxLength={12} disabled={flag !== 'edit'} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.firstName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="firstName"
                                            >
                                                <Input type="text" placeholder={trans.firstName[Config.backLang]} disabled={flag !== 'edit'} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.lastName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="lastName"
                                            >
                                                <Input type="text" placeholder={trans.lastName[Config.backLang]} disabled={flag !== 'edit'} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">WhatsApp</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="whatsApp"
                                            >
                                                <Input type="text" placeholder="WhatsApp" maxLength={50} disabled={flag !== 'edit'} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">WeChat</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="weChat"
                                            >
                                                <Input className="input" type="text" placeholder="WeChat" maxLength={50} disabled={flag !== 'edit'} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">LinkedIn</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="linkedIn"
                                            >
                                                <Input className="input" type="text" placeholder="LinkedIn" maxLength={50} disabled={flag !== 'edit'} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">Personal Web</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="personalWeb"
                                            >
                                                <Input className="input" type="text" placeholder="Personal Web" maxLength={50} disabled={flag !== 'edit'} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysColMax'>
                                        <div className="sysParam">Resume</div>
                                        <div className="linkBox">
                                            {jobApplModel.annexName && <div className='tag' title={jobApplModel.annexName} onClick={() => downloadFile({ name: jobApplModel.annexName, path: jobApplModel.storagePath }, jobApplModel.resumeType === 'SELECT')}>
                                                <img src={tag1} className="tagImg"></img>{jobApplModel.annexName}
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysColMax'>
                                        <div className="sysParam">Portfolio Link</div>
                                        <div className="linkBox">
                                            {jobApplModel.portfolioLinkOne &&
                                                <div className='tag'>
                                                    <img src={tag2} className="tagImg"></img><a href={(jobApplModel.portfolioLinkOne && !jobApplModel.portfolioLinkOne.startsWith('https://')) ? 'https://' + jobApplModel.portfolioLinkOne : jobApplModel.portfolioLinkOne} title={jobApplModel.portfolioLinkOne} target="_blank" rel="noreferrer">{jobApplModel.portfolioLinkOneDesc ? jobApplModel.portfolioLinkOneDesc : jobApplModel.portfolioLinkOne}</a>
                                                </div>
                                            }
                                            {jobApplModel.portfolioLinkTwo &&
                                                <div className='tag'>
                                                    <img src={tag2} className="tagImg"></img><a href={(jobApplModel.portfolioLinkTwo && !jobApplModel.portfolioLinkTwo.startsWith('https://')) ? 'https://' + jobApplModel.portfolioLinkTwo : jobApplModel.portfolioLinkTwo} title={jobApplModel.portfolioLinkTwo} target="_blank" rel="noreferrer">{jobApplModel.portfolioLinkTwoDesc ? jobApplModel.portfolioLinkTwoDesc : jobApplModel.portfolioLinkTwo}</a>
                                                </div>
                                            }
                                            {jobApplModel.portfolioLinkThree &&
                                                <div className='tag'>
                                                    <img src={tag2} className="tagImg"></img><a href={(jobApplModel.portfolioLinkThree && !jobApplModel.portfolioLinkThree.startsWith('https://')) ? 'https://' + jobApplModel.portfolioLinkThree : jobApplModel.portfolioLinkThree} title={jobApplModel.portfolioLinkThree} target="_blank" rel="noreferrer">{jobApplModel.portfolioLinkThreeDesc ? jobApplModel.portfolioLinkThreeDesc : jobApplModel.portfolioLinkThree}</a>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysColMax'>
                                        <div className="sysParam">Additional Attachment</div>
                                        <div className="linkBox">
                                            {jobApplModel.jobApplAnnexModelList?.map((item, index) =>
                                                !item.jobApplEventId &&
                                                <div className='flexfileBox' key={index}>
                                                    {/* <div className='fileTypeBox'>
                                                        {item.fileTypeVal}
                                                    </div> */}
                                                    {item.fileTypeVal}
                                                    <div className='tag' key={item.jobApplAnnexId} title={item.annexName} onClick={() => downloadFile({ name: item.annexName, path: item.storagePath })}>
                                                        <img src={tag1} className="tagImg"></img>{item.annexName}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysColMax'>
                                        <div className="sysParam">Additional Comment</div>
                                        <div className="sysInputs">
                                            <TextArea rows={3} placeholder="Additional Comment" value={jobApplModel?.additionalInfo} disabled />
                                        </div>
                                    </div>
                                </div>
                                {jobApplModel?.eventRequestDocumentList?.map((item, index) =>
                                    <div key={index} className='documentRemarkBox'>
                                        <div className='flexBox'>
                                            <div className='label'><span style={{ color: '#0059AC', fontWeight: 'bold' }}>{index + 1} </span>IP Request More Info</div>
                                            <div className='valueJustify value2'>{item.eventRemark}</div>
                                        </div>
                                        {jobApplModel?.eventDocumenAttachedList[index] &&
                                            <>
                                                {jobApplModel?.eventDocumenAttachedList[index]?.eventRemark &&
                                                    <div className='flexBox'>
                                                        <div className='label'>Additional Information</div>
                                                        <div className='valueJustify value2'>{jobApplModel?.eventDocumenAttachedList[index]?.eventRemark}</div>
                                                    </div>
                                                }
                                                {
                                                    item?.jobApplAnnexModelList?.map((item, i) =>
                                                        <div className='flexDocumentBox' key={i}>
                                                            {
                                                                i == 0 ? <div className='label'>Additional Attachment</div> : <div className='label'></div>
                                                            }
                                                            <div className='linkBox'>
                                                                <div className='tag' key={item.jobApplAnnexId} title={item.annexName} onClick={() => downloadFile({ name: item.annexName, path: item.storagePath })}>
                                                                    <img src={tag1} className="tagImg"></img>{item.annexName}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                            </>
                                        }
                                    </div>
                                )}
                                {jobApplModel?.eventDialogList?.map((item, index) =>
                                    !Base.isEmptyObject(item) && <div key={index} className='documentRemarkBox'>
                                        <div className='flexBox'>
                                            <div className='label'>Application<span style={{ color: '#0059AC', fontWeight: 'bold' }}> {index + 1} </span>Dialog</div>
                                        </div>
                                        {item?.studentWithdawnRemark && <div className='flexBox'>
                                            <div className='label'>Withdrawn Job Application Reason</div>
                                            <div className='valueJustify value2'>{item.studentWithdawnRemark}</div>
                                        </div>}
                                        {item?.specialRemark && <div className='flexBox'>
                                            <div className='label'>Special Arrangement Remark</div>
                                            <div className='valueJustify value2'>{item.specialRemark}</div>
                                        </div>}
                                        {item?.rejectedRemark && <div className='flexBox'>
                                            <div className='label'>MC Reject Appliction Reason</div>
                                            <div className='valueJustify value2'>{item.rejectedRemark}</div>
                                        </div>}
                                        {item?.offerEventRemark && <div className='flexBox'>
                                            <div className='label'>IP Make Offer Additional Info</div>
                                            <div className='valueJustify value2'>{item.offerEventRemark}</div>
                                        </div>}
                                        {item?.offerDeclinedRemark && <div className='flexBox'>
                                            <div className='label'>Offer Rejected Reason</div>
                                            <div className='valueJustify value2'>{item.offerDeclinedRemark}</div>
                                        </div>}
                                    </div>
                                )}
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" hidden={Config.funcInfo.canUpdate === "N" || flag !== 'edit'} disabled={isLoad} htmlType="submit" icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
        </div>
    )

}
export default JobApplicationRecord;